import { useEffect, useState } from 'react'
import { useApi } from '../classes/appApi'
import { useOffline } from '../components/App/AppOfflineContext'
import { useRouterContext } from '../components/App/AppRouter'
import BusinessFunctionBadge from '../components/BusinessFunctionBadge'
import MainLayout from '../components/MainLayout'
import { ControlledDocumentSummaryModel } from '../defs/defs'
import EqxCard from '../shared/components/EqxCard/EqxCard'
import EqxFilter from '../shared/components/EqxFilter/EqxFilter'
import { EqxLink } from '@equinoxx/react'
import EqxListGroup, { EqxListGroupItem } from '../shared/components/EqxListGroup/EqxListGroup'
import EqxRequestHandler from '../shared/components/EqxRequestHandler/EqxRequestHandler'
import useApiEndpoint from '../shared/hooks/ApiEndpoint'

const PageControlledDocumentIndex = () => {
    const api = useApi()
    const { response: documents, loading, error } = useApiEndpoint<ControlledDocumentSummaryModel[]>(api, api.endpoints.controlledDocuments())
    const router = useRouterContext()
    const { isOffline, isFileCached } = useOffline()
    const [filteredDocuments, setFilteredDocuments] = useState<ControlledDocumentSummaryModel[]>([])

    // Initialize filtered documents when data loads
    useEffect(() => {
        if (documents) {
            setFilteredDocuments(documents)
        }
    }, [documents])

    return (
        <MainLayout pageTitle="Controlled Documents">
            <EqxRequestHandler
                state={{ loading, error: error ?? null }}
                isEmpty={documents?.length === 0}
                empty={<div className="p-5 text-center text-muted">No controlled documents found</div>}
            >
                <EqxCard isSection noPadding header={
                    <EqxFilter
                        data={documents!}
                        onFilterChange={setFilteredDocuments}
                        placeholder="Search documents by title or reference..."
                        searchKeys={['title', 'reference']}
                    />
                }>
                    {filteredDocuments && filteredDocuments.length > 0 ? (
                        <EqxListGroup isChild>
                            {filteredDocuments.map((doc) => (
                                <EqxListGroupItem key={doc.id}>
                                    <div className="clickable d-flex" onClick={() => router.navigate(`/controlled-documents/${doc.id}`)}>
                                        <div className="m-1 me-3">{doc.businessFunction && <BusinessFunctionBadge businessFunction={doc.businessFunction} />}</div>
                                        <div className="flex-grow-1">
                                            <h6 className="mb-0"><EqxLink to={`/controlled-documents/${doc.id}`} className={isOffline && !isFileCached(`/controlled-documents/${doc.id}`) ? 'unavailable' : ''}>{doc.title}</EqxLink></h6>
                                            <div className="small text-muted">{doc.reference}</div>
                                        </div>
                                        <div className="ms-3"><span className="badge bg-secondary">{doc.type?.name}</span></div>
                                    </div>
                                </EqxListGroupItem>
                            ))}
                        </EqxListGroup>
                    ) : (
                        <div className="p-5 text-center text-muted">
                            {documents && documents.length > 0 ? 'No documents match your search criteria' : 'No controlled documents found'}
                        </div>
                    )}
                </EqxCard>
            </EqxRequestHandler>
        </MainLayout>
    )
}

export default PageControlledDocumentIndex 